<template>

<router-link v-if="!isRedirect" :to="toFinal">

	<slot></slot>

</router-link>

<a v-else :href="href">

	<slot></slot>

</a>

</template>

<script>

export default {

	props: ['to'],

	computed: {

		isRedirect: function() {

			if (process.env.VUE_APP_TYPE === 'subdomain' || process.env.VUE_APP_TYPE === 'externaldomain') {

				if (this.to && this.to.params && this.to.params.type) {

					if (this.$subdomain.type !== this.to.params.type || this.$subdomain.name !== this.to.params.name) {

						return this.to.params

					}

				}

			}

			return false

		},

		href: function() {

			if (this.isRedirect) {

				return 'https://geekgroup.app/' + this.isRedirect.type + '/' + this.isRedirect.name

			}

			return null

		},

		toFinal: function() {

			return (this.isRedirect) ? {} : this.to

		}

	}

}

</script>

<style scoped>

</style>
